var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "layout-head-nav" },
    [
      _c(
        "el-menu",
        {
          staticClass: "f-b-c def-w",
          attrs: {
            "default-active": _vm.activeMenu.path,
            "background-color": "#444",
            "text-color": "#fff",
            "active-text-color": "#fff",
            "unique-opened": true,
            mode: "horizontal",
          },
        },
        _vm._l(_vm.menus, function (route) {
          return _c("nav-item", {
            key: route.id,
            attrs: {
              "active-index": _vm.activeMenu.path,
              item: route,
              "base-path": route.path,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }